// This file is intended to be used for any constants that pertain to typography

/* Font weight overrides to be used in tandem with a typography class */
export const fontWeights = {
  book: 400,
  semibold: 600,
}
